import { stringToQuery } from 'utils'
import ConfigService from './ConfigService'
import BaseService from './BaseService'

export default new (class KwkService extends BaseService {
  constructor() {
    super({
      baseURL: () => ConfigService.get('api.kwk')
    })

    const { kdnr } = stringToQuery(document.location.hash.slice(1))
    this.customerNumber = /^\d+$/.test(kdnr) ? kdnr : ''
  }

  setCustomerNumber(customerNumber) {
    this.customerNumber = customerNumber
  }

  send(data) {
    return this.post('/frontend/kwk/send-mail', data).catch(error => {
      const { data, status } = error.response

      if (status === 400) {
        return Promise.reject({ fieldErrors: data || [] })
      }

      return Promise.reject(error)
    })
  }

  createPromotionLink({ channel, productArea }) {
    return this.post('/frontend/kwk/social-share-data', {
      channel,
      productArea,
      customerNumber: this.customerNumber
    }).then(({ data }) => data.url)
  }
})()
